import React from 'react';
import { useSelector } from 'react-redux';
import { renderMaxLengthText } from 'utils/renderMaxLengthText';
import FadeInImage from 'components/FadeInImage';
import './style.scss';

export const ProfileAvatar = ({
  avatarSrc,
  onClick,
  profileName,
  editable,
  menuView = false,
  selected = false,
}) => {
  const assets = useSelector(state => state.asset);

  return (
    <div
      className={`profile-avatar ${menuView ? 'menu-view' : ''} ${
        selected ? 'selected' : ''
      }`}
      onClick={onClick}
    >
      {editable && (
        <div className="profile-avatar__overlay fade__in">
          <div className="profile-avatar__overlay__layer" />
          <img
            className="profile-avatar__overlay__img"
            src={assets.listProfiles_access_option_icon_updateProfile}
            alt="cv-profile-opt"
          />
        </div>
      )}
      <div className="profile-avatar__img">
        <FadeInImage
          imageSrc={avatarSrc}
          imageAlt="clarovideo-avatar"
          width={160}
          height={160}
          classNames={['profile-avatar__img__tag']}
        />
      </div>
      <span className="profile-avatar__name">
        {renderMaxLengthText(profileName, 10)}
      </span>
    </div>
  );
};
